import BaseRestApi from '@/services/BaseRestApi';
import BaremeDto from '@/models/BaremeDto';
// import PeriodeFiscaleDto from '@/models/calculette/PeriodeFiscaleDto';
import RestErreur from '@/utils/RestErreur';

export default class BaremeRestApi extends BaseRestApi {
  get resource() { // eslint-disable-line
    return '/bareme';
  }

  async getBarameForYear(iniAnnee) {
    try {
      const coAnswer = await this.getApi().get(`${this.resource}/list/${iniAnnee}`);

      if (coAnswer.status === 200) {
        if (coAnswer.data) {
          return BaremeDto.jsonToList(coAnswer.data, BaremeDto.getFactory);
        }
        return new RestErreur(`Pas de résultat pour cette année: ${iniAnnee}`, coAnswer);
      }
      return new RestErreur('Rest api barème warning', coAnswer);
    } catch (inexError) {
      return new RestErreur('Rest api bareme erreur', inexError);
    }
  }

  async getListePeriodeFiscale(nbMax) {
    try {
      const coAnswer = await this.getApi().get(`${this.resource}/lastPeriod/${nbMax}`);

      if (coAnswer.status === 200) {
        if (coAnswer.data) {
          return coAnswer.data;
        }
        return new RestErreur('Pas de période fiscale pour cette ce code barème:', coAnswer);
      }
      return new RestErreur('Rest api barème warning', coAnswer);
    } catch (inexError) {
      return new RestErreur('Rest api bareme erreur', inexError);
    }
  }

  async determinerBareme(contribuableIsDto) {
    try {
      const coAnswer = await this.getApi().post(`${this.resource}/determinerBareme`, contribuableIsDto);

      if (coAnswer.status === 200) {
        if (coAnswer.data) {
          return coAnswer.data;
        }
        return new RestErreur("Erreur lors de l'appel /determinerBareme", coAnswer);
      }
      return new RestErreur('Rest api barème warning', coAnswer);
    } catch (inexError) {
      return new RestErreur('Rest api bareme erreur', inexError);
    }
  }

  async getListePeriodeFiscaleFormulairePrelevement() {
    try {
      const coAnswer = await this.getApi().get(`${this.resource}/lastPeriodPrelevement`);

      if (coAnswer.status === 200) {
        if (coAnswer.data) {
          return coAnswer.data;
        }
        return new RestErreur('Pas de période fiscale pour cette ce code barème:', coAnswer);
      }
      return new RestErreur('Rest api barème warning', coAnswer);
    } catch (inexError) {
      return new RestErreur('Rest api bareme erreur', inexError);
    }
  }
}
